import { graphql } from '@/gql/generated'

// TODO: We should set up a computed field for lowercasing the username
// and add a unique index on the lowercased username to improve performance
export const getProfileByUserNameQueryDocument = graphql(/* GraphQL */ `
  query GetProfileByUserName($username: String!) {
    user_profiles(where: { username: { _ilike: $username } }) {
      id
    }
  }
`)
